import { render } from "./todayBill.vue?vue&type=template&id=08bb7530&scoped=true"
import script from "./todayBill.vue?vue&type=script&lang=js"
export * from "./todayBill.vue?vue&type=script&lang=js"

import "./todayBill.vue?vue&type=style&index=0&id=08bb7530&scoped=true&lang=css"
import "./todayBill.vue?vue&type=style&index=1&id=08bb7530&lang=css"
script.render = render
script.__scopeId = "data-v-08bb7530"

export default script